import React, { useMemo } from 'react';

import CalendarSchedule from './CalendarSchedule';
import { byDateCalendar } from './byDateCalendar';

/**
 * A semester kept by date, in the calendar the short semesters already use.
 *
 * <p>The table is the same; only the question "what is on this date" is answered differently. A
 * week-based semester derives it from the parity of the week, which this one cannot — beyond a
 * fortnight two of its Saturdays fall in the same parity, and one item would be drawn on both.
 * Here the dates come from the server and the items are matched to them directly.
 *
 * <p>Serves the group view and the whole-semester view alike: a group's schedule is simply the
 * same response narrowed to one group, so it arrives with one column instead of several.
 */
const CalendarScheduleByDate = ({ byDate, viewMode, t }) => {
    const { fullSchedule, cardsFor } = useMemo(() => byDateCalendar(byDate), [byDate]);

    return (
        <CalendarSchedule
            fullSchedule={fullSchedule}
            viewMode={viewMode}
            t={t}
            cardsFor={cardsFor}
        />
    );
};

export default CalendarScheduleByDate;